import React, { useState, useEffect } from "react"
import './index.css';
import { Button, Modal, Form, Dropdown } from "react-bootstrap";
import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import BfPlaceBet from "./bfPlaceBet";
import { connect } from "react-redux"
import { UPDATE_TOKEN } from "./constants/action-types";
import { getLoginToken, clear, updateLoginToken, LOGIN_API, updateUserName, getBetIdsFromServer } from "./constants/utils";

const BfLogin = (props) => {

  const [bfLogin, setBfLogin] = useState(false)
  const [bfLoginId, setBfLoginId] = useState('')
  const [bfPassword, setBfPassword] = useState('')
  const [show, setShow] = useState(false);
  const [country, setCountry] = useState('ALL');

  const countryDomain = {
    'ALL': 'Betfair.com(Default)',
    'RO': 'Betfair.ro(Romania)',
    'IT': 'Betfair.it(Italy)',
    'SE': 'Betfair.se(Sweden)',
    'ES': 'Betfair.es(Spain)',
  }

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  /** Clear Betfair Details On Browser/Tab Close */
  useEffect(() => {
    const handleTabClose = event => {
      event.preventDefault();
      clear();
    };
    window.addEventListener('beforeunload', handleTabClose);
    return () => {
      window.removeEventListener('beforeunload', handleTabClose);
    };
  }, []);
  

  useEffect(() => {
    const items = getLoginToken();
    if (items) {
      setBfLogin(true)
    } else {
      setBfLogin(false)
    }
  }, [props.loginToken]);

  const handleLogin = () => {
    const postRequestPara = {
      "userName": bfLoginId,
      "password": bfPassword,
      "country" : country,
      "clientReference": "gpmwebbot"
    }

    axios.post(LOGIN_API, postRequestPara)
      .then((res) => {
        //console.log("Result of LOGIN API ::" + res.data)
        const token = res.data
        if (token) {
          updateLoginToken(token)
          updateUserName(bfLoginId)
          getBetIdsFromServer(bfLoginId);
          setBfLogin(true)
          props.setLoginToken(token)
        }
      },
        (error) => {
          //console.log("Result of API 3 returns Error!!!" + error)
          NotificationManager.error('Error in Login', '', 5000, () => {
            console.log('Error message notification clicked');
          });
        });
    handleClose();
  }

  function handleCountry(evt) {
    console.log(evt);
    setCountry(evt);
  }

  const loginModal = (
    <>
      <Button size="sm" onClick={handleShow}>
        Bf Login
      </Button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Greyhound Price Monitor Betfair Login</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "0.753m", fontWeight: "700" }}>
          <center>Please enter your betfair Username, Password and select your domain
            (default would work for most) and press the "Login" button</center>
          <center>Or </center>
          <center>Select only the Domain and press the "Interactive Login" Button.</center>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Login</Form.Label>
              <Form.Control
                type="text"
                onChange={(event) => { setBfLoginId(event.target.value) }}
                placeholder="Login Id"
                autoFocus
              />
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" onChange={(event) => { setBfPassword(event.target.value) }} placeholder="Password" />
            </Form.Group>
            <Form.Group>
              <Form.Label>Domain</Form.Label>
              <Dropdown size="sm" title='Select Value' onSelect={handleCountry}>
                <Dropdown.Toggle size="sm" style={{ backgroundColor: '#303f9f' }}>
                  {countryDomain[country]}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item eventKey="ALL">Betfair.com(Default)</Dropdown.Item>
                  <Dropdown.Item eventKey="RO">Betfair.ro(Romania)</Dropdown.Item>
                  <Dropdown.Item eventKey="IT">Betfair.it(Italy)</Dropdown.Item>
                  <Dropdown.Item eventKey="SE">Betfair.se(Sweden)</Dropdown.Item>
                  <Dropdown.Item eventKey="ES">Betfair.es(Spain)</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleLogin}>
            Login
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
  return (
    <>
      {bfLogin ? <BfPlaceBet suspended={props.suspended} marketName={props.marketName} marketId={props.marketId}
        runner={props.runner}></BfPlaceBet> : loginModal}
    </>
  )
}

const mapStateToProps = state => {
  return {
    loginToken: state.loginToken,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setLoginToken: payload =>
      dispatch({ type: UPDATE_TOKEN, payload: payload }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BfLogin);
